import { render, staticRenderFns } from "./game.vue?vue&type=template&id=c8702936&scoped=true"
import script from "./game.vue?vue&type=script&lang=ts"
export * from "./game.vue?vue&type=script&lang=ts"
import style0 from "./game.vue?vue&type=style&index=0&id=c8702936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8702936",
  null
  
)

export default component.exports